import React from "react";
import CustomerListPage from "../../site-params/categories/categories";

const ArticlesCategories = () => {
  return <CustomerListPage parentNumber={10} />;
};

export default ArticlesCategories;
